import type { ReactNode } from 'react';
import styles from './SummaryCard.module.css';
import Text, { TEXT_VARIANT, TEXT_TAG } from '@pixum/text';
import { LinkWithMasking } from 'components';

export interface SummaryCardProps {
  title: string;
  actionLabel: string;
  /** Called on click; with `href` the link still navigates afterwards, so it can be used for tracking. */
  onAction?: () => void;
  /** Without it the action renders as a button. Server components must omit `onAction`. */
  href?: string;
  children: ReactNode;
}

export function SummaryCard({ title, actionLabel, onAction, href, children }: SummaryCardProps) {
  return (
    <section className={styles.summaryCard} aria-label={title}>
      <div className={styles.header}>
        <Text className={styles.title} variant={TEXT_VARIANT.HEADLINE} tag={TEXT_TAG.H2}>
          {title}
        </Text>
        <Text variant={TEXT_VARIANT.CAPTION} tag={TEXT_TAG.DIV}>
          <LinkWithMasking href={href ?? '#edit'} masked={false} onClick={onAction}>
            {actionLabel}
          </LinkWithMasking>
        </Text>
      </div>
      <div className={styles.content}>{children}</div>
    </section>
  );
}
